<template>
  <div class="app-container">
    <!-- 主要内容区域 -->
    <div class="main-content">
      <div class="bgk-img">
        <img src="https://www.hketang.cn/_nuxt/img/course-banner.2811f9b.png" alt="" />
      </div>
      <div class="tabs-box">
        <div class="tabs">
          <div class="tab left" @click="tabschange(1)"  :class="tabsactive == 1 ? 'active':''">编程学院</div>
          <div class="tab" @click="tabschange(2)"  :class="tabsactive == 2 ? 'active':''">公开课</div>
          <div class="tab" @click="tabschange(3)" :class="tabsactive == 3 ? 'active':''">进阶课</div>
          <div class="tab" @click="tabschange(4)" :class="tabsactive == 4 ? 'active':''">专项课</div>
          <div class="tab right" @click="tabschange(5)" :class="tabsactive == 5 ? 'active':''">综合课</div>
        </div>
        <div class="listbox">
          <div class="classlist" v-for="(item, i) in collegeList" :key="i" @click="handledetal(item)">
              <div class="infobox">
                <img :src="item.coverUrl" alt="" />
                <div class="info">
                  <span class="title">{{ item.name }}</span>
                  <span class="type">{{ item.typeName || '课程' }}</span>
                </div>
              </div>
              <div class="perinfo">
                <img :src="item.teacherAvatars && item.teacherAvatars[0] ? item.teacherAvatars[0] : 'https://web-1322480718.cos.ap-nanjing.myqcloud.com/20240807/20240807122351_esxl.jpg'" alt="" />
                <div class="pername">{{ item.teacherNames && item.teacherNames[0] ? item.teacherNames[0] : '讲师' }}</div>
              </div>
              <div class="money">{{ item.fee ? '￥' + item.fee : '免费' }}</div>
              <div class="signup">
                <span class="nums">{{ item.applicantsNumber }}</span>
                人报名
              </div>
            </div>
            <el-pagination
              background
              layout="prev, pager, next"
              style="text-align: right"
              :total="total"
              :page-size="pagesize"
              :current-page="currentPage"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
        </div>
       
      </div>
    </div>
  </div>
</template>

<script>
import { courseinfo } from "@/api/index.js";
export default {
  name: "home",
  components: {},
  data() {
    return {
      tabsactive: 1,
      total: 0,
      pagesize: 10,
      currentPage: 1,
      collegeList: [],
    };
  },
  computed: {
   
  },
  created() {
    this.tabsactive = this.$store.state.classtype || 1;
    this.getcourseinfo();
  },
  
  methods: {
    tabschange(val) {
      this.tabsactive = val;
      this.$store.commit('classtype', val);
      this.currentPage = 1; // 切换类型时重置页码
      this.getcourseinfo();
    },
    getcourseinfo() {
      // 根据tabsactive映射到后端的type值
      let typeMap = {
        1: "1", // 编程学院
        2: "2", // 公开课
        3: "3", // 进阶课
        4: "4", // 专项课
        5: "5", // 综合课
      };
      
      courseinfo({
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        typeId: typeMap[this.tabsactive],
      }).then((res) => {
        if (res.data && res.data.list) {
          this.collegeList = res.data.list;
          this.total = res.data.total || 0;
        } else {
          this.collegeList = [];
          this.total = 0;
        }
      }).catch(error => {
        console.error('获取课程信息失败:', error);
        this.collegeList = [];
        this.total = 0;
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getcourseinfo();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.currentPage = 1; // 改变页面大小时重置页码
      this.getcourseinfo();
    },
    handledetal(val) {
      this.$store.commit("activeNavIndex", 1);
      this.$router.push({ path: "/coursedetals", query: { id: val.id } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转错误:', err);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.app-container {
  background-color: rgb(255, 255, 255);

  padding: 0;
  margin: 0;
  font-family: "Microsoft YaHei";
  color: #333;
  overflow: hidden;
  clear: both;
  .main-content {
    .bgk-img {
      width: 100%;
      height: 210px;
      z-index: 2;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .tabs-box{
      width: 100%;
      font-size: 18px;
      background-color: #f5f6f9;
      padding: 0 0 60px 0;
      .tabs {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        margin-top: -30px;
        .tab{
          width: 300px;
          height: 74px;
          background: #f5f6f9;
          font-weight: 500;
          color: #2d3341;
          line-height: 74px;
          cursor: pointer;
        }
        .left {
          
          border-top-left-radius: 20px;
        }
        .right {
         
          border-top-right-radius: 20px;
          cursor: pointer;
        }
        .active{
            background: #fff;
            padding:20px 0 0 0;
            margin-top: -20px;
            border-top-right-radius: 20px;
            border-top-left-radius: 20px;
        }
      }
      .listbox{
        width: 1140px;
        margin: 0 auto;
        background: #fff;
        // display: flex;
        // justify-content: space-between;
        // flex-wrap: wrap;
        padding: 30px;
        
        .classlist {
          width: 1076px;
          height: 98px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;
          cursor: pointer;
          .infobox {
            width: 362px;
            font-size: 16px;
            text-align: left;
            display: flex;
            align-items: center;
            margin-right: 20px;
            img {
              width: 154px;
              height: 98px;
              margin-right: 25px;
            }
            .info {
              height: 60px;
              .title {
                display: block;
                color: #2d3341;
                margin-bottom: 20px;
              }
              .type {
                display: block;
                color: #838a9d;
              }
            }
          }
          .perinfo {
            display: flex;
            align-items: center;
            width: 242px;
            img {
              width: 42px;
              height: 42px;
              border-radius: 50%;
              margin-right: 10px;
            }
            .pername {
              color: #838a9d;
              font-size: 16px;
              margin-bottom: 10px;
            }
          }
          .money {
            width: 226px;
            color: #d5182f;
          }
          .signup {
            width: 226px;
            .nums {
              color: #d5182f;
            }
          }
        }
      }
    }
   
  }
}

/* ====== Mobile responsive overrides for Course List page ====== */
@media (max-width: 1200px) {
  .app-container .main-content .tabs-box .tabs {
    width: auto;
    padding: 0 12px;
  }
  .app-container .main-content .tabs-box .listbox {
    width: auto;
    padding: 20px 12px;
  }
}

@media (max-width: 992px) {
  .app-container .main-content .tabs-box .tabs {
    flex-wrap: wrap;
    margin-top: 0;
  }
  .app-container .main-content .tabs-box .tabs .tab {
    width: 50%;
    height: 56px;
    line-height: 56px;
    border-radius: 0;
  }
  .app-container .main-content .tabs-box .listbox .classlist {
    width: 100%;
    height: auto;
    flex-wrap: wrap;
    align-items: flex-start;
    padding: 12px;
  }
  .app-container .main-content .tabs-box .listbox .classlist .infobox {
    width: 100%;
    margin: 0 0 10px 0;
  }
  .app-container .main-content .tabs-box .listbox .classlist .infobox img {
    width: 100%;
    height: auto;
    margin-right: 0;
  }
  .app-container .main-content .tabs-box .listbox .classlist .perinfo,
  .app-container .main-content .tabs-box .listbox .classlist .money,
  .app-container .main-content .tabs-box .listbox .classlist .signup {
    width: auto;
    margin-right: 12px;
  }
}

@media (max-width: 600px) {
  .app-container .main-content .tabs-box .tabs .tab {
    width: 100%;
  }
  .app-container .main-content .tabs-box .listbox .classlist {
    padding: 10px 6px;
  }
  .app-container .main-content .tabs-box .listbox .classlist .perinfo img {
    width: 36px;
    height: 36px;
  }
}
</style>
